function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/* ═══════════════════════════════════════════
   CART PAIR WIDGET
═══════════════════════════════════════════ */
class CartPairWidget {
  constructor() {
    this._slider    = null;
    this._sectionId = null;
    this._limit     = 4;
    this._btnLabel  = '+';
    this._subText   = '';
  }

  init() {
    this._slider = document.querySelector('cart-pair-slider');
    if (!this._slider) return;

    this._sectionId = this._slider.dataset.sectionId;
    this._limit     = parseInt(this._slider.dataset.limit)  || 5;
    this._btnLabel  = this._slider.dataset.btnLabel         || '+';
    this._subText   = this._slider.dataset.subText          || '';

    this.refresh();
  }

  refresh(productId) {
    var self = this;
    this._slider = document.querySelector('cart-pair-slider');
    if (!this._slider) return;

    if (productId) {
      this._fetchAndRender(String(productId));
      return;
    }

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.items && cart.items.length) {
          self._fetchAndRender(String(cart.items[0].product_id));
        } else {
          self._hide();
        }
      })
      .catch(function() {});
  }

  _hide() {
    var wrapper = this._slider
      ? this._slider.closest('.cpw-slider-wrapper-' + this._sectionId)
      : null;
    if (wrapper) wrapper.style.display = 'none';
  }

  _show() {
    var wrapper = this._slider
      ? this._slider.closest('.cpw-slider-wrapper-' + this._sectionId)
      : null;
    if (wrapper) wrapper.style.display = '';
  }

  _showSkeleton(slider) {
    var sid   = this._sectionId;
    var count = this._limit || 3;
    var skels = '';

    for (var i = 0; i < count; i++) {
      skels += '<div class="cpw-card-' + sid + ' cpw-card--skeleton" style="position:relative;">'
        + '<div class="cpw-img-placeholder-' + sid + ' cpw-skeleton-pulse"></div>'
        + '<div class="cpw-content-' + sid + '">'
        + '<div class="cpw-skeleton-line" style="width:80%;height:12px;margin-bottom:8px;"></div>'
        + '<div class="cpw-skeleton-line" style="width:55%;height:10px;margin-bottom:14px;"></div>'
        + '<div class="cpw-skeleton-line" style="width:100%;height:36px;"></div>'
        + '</div>'
        + '</div>';
    }

    slider.innerHTML = skels;
    slider._index = 0;
    if (typeof slider._updateTransform === 'function') slider._updateTransform();
  }

  _fetchAndRender(productId) {
    var self   = this;
    var slider = document.querySelector('cart-pair-slider');
    if (!slider) return;

    var recsUrl = slider.dataset.recsUrl;
    if (!recsUrl) return;

    /* Show skeleton immediately — preserves height */
    this._showSkeleton(slider);

    var url = recsUrl
      + '?section_id=cart-pair-recs'
      + '&product_id=' + productId
      + '&limit=' + this._limit;

    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc      = new DOMParser().parseFromString(html, 'text/html');
        var items    = doc.querySelectorAll('[data-pair-product]');
        var products = Array.from(items).map(function(el) {
          return {
            id:        el.dataset.pairProduct,
            variantId: el.dataset.variantId,
            title:     el.dataset.title,
            price:     el.dataset.price,
            image:     el.dataset.image,
            url:       el.dataset.url,
            handle:    el.dataset.handle,
            description: el.dataset.description
          };
        });

        if (!products.length) { self._hide(); return; }
        self._show();
        self._renderCards(slider, products);
      })
      .catch(function(e) { console.error('[CPW] fetch error:', e); });
  }

  _renderCards(slider, products) {
    var self = this;
    var sid  = this._sectionId;

    slider.innerHTML = products.map(function(p) {
      return '<div class="cpw-card-' + sid + '" data-variant-id="' + p.variantId + '" style="position:relative;">'
        + '<a href="' + p.url + '">'
        + (p.image
          ? '<img class="cpw-img-' + sid + '" src="' + p.image + '" alt="' + p.title + '" loading="lazy">'
          : '<div class="cpw-img-placeholder-' + sid + '"></div>')
        + '</a>'
        + '<div class="cpw-content-' + sid + '">'
        + '<a href="' + p.url + '"><p class="cpw-name-' + sid + '">' + p.title + '</p></a>'
        + '<div class="cpw-sub-text-buttton-' + sid + '">'
        + ((p.description || self._subText) ? '<p class="cpw-sub-' + sid + '">' + (p.description || self._subText) + '</p>' : '')
        + '<button class="cpw-btn-' + sid + '" data-cpw-atc'
        + ' data-variant="' + p.variantId + '"'
        + ' data-product-handle="' + (p.handle || '') + '"'
        + ' data-price="' + p.price + '"'
         + ' data-desc="' + p.description + '"'
        + ' data-variant-selected="false">'
        + self._btnLabel
        + '</button>'
         + '</div>'
        + '</div>'
        /* Popup — options only */
        + '<div class="cpw-popup-' + sid + ' cpw-popup" style="display:none;">'
        + '<div class="cpw-popup__inner">'
        + '<div class="cpw-popup__close" data-cpw-close>&#10005;</div>'
        + '<div class="cpw-popup__options" data-cpw-options></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    }).join('');

    slider._index = 0;
    slider._updateTransform();

    this._bindATC(slider);
  }

  _bindATC(slider) {
    var self = this;
    var sid  = this._sectionId;

    var COLOR_KEYWORDS = ['color', 'colour', 'metal', 'material'];

    var COLOR_MAP = {
      'yellow gold': '#E7BC63', 'gold': '#E7BC63',   'yellow': '#E7BC63',
      'rose gold':   '#E8C4B4', 'rose': '#E8C4B4',   'pink gold': '#E8C4B4', 'pink': '#E8C4B4',
      'white gold':  '#E1E0DB', 'silver': '#E1E0DB', 'platinum': '#E1E0DB',
      'white':       '#ffffff', 'black': '#111111',  'black gold': '#2a2a2a'
    };

    function isColorOption(name) {
      var n = (name || '').toLowerCase();
      for (var i = 0; i < COLOR_KEYWORDS.length; i++) {
        if (n.indexOf(COLOR_KEYWORDS[i]) > -1) return true;
      }
      return false;
    }

    function getSwatchColor(val) {
      var n = (val || '').toLowerCase().trim();
      if (COLOR_MAP[n]) return COLOR_MAP[n];
      for (var k in COLOR_MAP) {
        if (n.indexOf(k) > -1 || k.indexOf(n) > -1) return COLOR_MAP[k];
      }
      return '#eaeaea';
    }

    function isDefaultVariantOnly(productData) {
      if (!productData) return true;
      var variants = productData.variants || [];
      if (variants.length <= 1) return true;
      var options = productData.options || [];
      if (options.length === 1) {
        var optName = typeof options[0] === 'string' ? options[0] : (options[0].name || '');
        if (optName === 'Title') return true;
      }
      return false;
    }

   function getMatchingVariant(productData, selected) {
      var variants = productData.variants || [];
      var options  = (productData.options || []).map(function(o) {
        return typeof o === 'string' ? o : (o.name || o);
      });
      return variants.find(function(v) {
        return options.every(function(opt, oi) {
          return v['option' + (oi + 1)] === selected[oi];
        });
      }) || variants[0];
    }


  function buildPopup(card, btn, productData) {
  var optionsEl = card.querySelector('[data-cpw-options]');
  if (!optionsEl || !productData) return;

  /* Normalize options to plain strings */
  var options  = (productData.options || []).map(function(o) {
    return typeof o === 'string' ? o : (o.name || String(o));
  });
  var variants = productData.variants || [];

  /* Filter out default-only */
  if (!options.length || (options.length === 1 && options[0] === 'Title')) return;

  optionsEl.innerHTML = '';

  var selected = {};
  options.forEach(function(optName, oi) {
    selected[oi] = variants[0] ? variants[0]['option' + (oi + 1)] : null;
  });

  function getMatchingVariant() {
    return variants.find(function(v) {
      return options.every(function(optName, oi) {
        return v['option' + (oi + 1)] === selected[oi];
      });
    }) || variants[0];
  }

  function updateBtn() {
    var v = getMatchingVariant();
    if (v) {
      btn.dataset.variant         = v.id;
      btn.dataset.variantSelected = 'true';
      var price = '$' + (Math.round(v.price) / 100).toFixed(2);
      btn.textContent = self._btnLabel ;
    }
  }

  options.forEach(function(optName, oi) {
    var isColor = isColorOption(optName);

    var seen   = {};
    var values = [];
    variants.forEach(function(v) {
      var val = v['option' + (oi + 1)];
      if (val && val !== 'Default Title' && !seen[val]) {
        seen[val] = true;
        values.push(val);
      }
    });

    if (!values.length) return;

    var groupEl = document.createElement('div');
    groupEl.className = 'cpw-option-group';
    groupEl.innerHTML = '<p class="cpw-option-label">' + optName + '</p>';

    var swatchWrap = document.createElement('div');
    swatchWrap.className = 'cpw-option-swatches'
      + (isColor ? ' cpw-option-swatches--color' : ' cpw-option-swatches--size');

    values.forEach(function(val) {
      var sw         = document.createElement('div');
      sw.className   = 'cpw-swatch' + (isColor ? ' cpw-swatch--color' : ' cpw-swatch--size');
      sw.textContent = isColor ? '' : val;
      sw.title       = val;
      sw.dataset.val = val;

      if (isColor) sw.style.backgroundColor = getSwatchColor(val);
      if (selected[oi] === val) sw.classList.add('is-active');

      // sw.addEventListener('click', function(e) {
      //   e.stopPropagation();
      //   swatchWrap.querySelectorAll('.cpw-swatch').forEach(function(s) {
      //     s.classList.remove('is-active');
      //   });
      //   sw.classList.add('is-active');
      //   selected[oi] = val;
      //   updateBtn();

      //   /* Close popup once all options selected */
      //   var allSelected = options.every(function(o, i) { return selected[i] != null; });
      //   if (allSelected) {
      //     var popup = card.querySelector('.cpw-popup-' + sid);
      //     if (popup) popup.style.display = 'none';
      //   }
      // });
        sw.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          swatchWrap.querySelectorAll('.cpw-swatch').forEach(function(s) {
            s.classList.remove('is-active');
          });
          sw.classList.add('is-active');
          selected[oi] = val;
          updateBtn();
          /* Auto-close removed — user closes manually or clicks ATC button */
        });

      swatchWrap.appendChild(sw);
    });

    groupEl.appendChild(swatchWrap);
    optionsEl.appendChild(groupEl);
  });

  updateBtn();
}


    function fetchProductData(handle, callback) {
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(callback)
        .catch(function() {});
    }

    function doATC(variantId, btn, originalText) {
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(function(r) {
        if (!r.ok) throw new Error('ATC failed');
        return r.json();
      })
      .then(function() {
        btn.classList.remove('loading');
        btn.classList.add('added');
        btn.textContent = '✓';

        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && cart.items && cart.items.length) {
              cartDrawer.updateQuantity(1, cart.items[0].quantity);
            }
            setTimeout(function() { self.refresh(); }, 300);
          })
          .catch(function() {});
      })
      .catch(function(err) {
        console.error('[CPW] ATC error:', err);
        btn.classList.remove('loading');
        btn.textContent = originalText;
      });
    }

    slider.querySelectorAll('[data-cpw-atc]').forEach(function(btn) {
      var card        = btn.closest('.cpw-card-' + sid);
      var popup       = card ? card.querySelector('.cpw-popup-' + sid) : null;
      var handle      = btn.dataset.productHandle;
      var productData = null;
      var fetching    = false;

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (btn.classList.contains('loading') || btn.classList.contains('added')) return;

        /* Close all other popups */
        slider.querySelectorAll('.cpw-popup').forEach(function(p) {
          if (p !== popup) p.style.display = 'none';
        });

        /* No handle — ATC directly */
        if (!handle || !popup) {
          var originalText = btn.textContent;
          btn.classList.add('loading');
          btn.textContent = '...';
          doATC(btn.dataset.variant, btn, originalText);
          return;
        }

      function afterFetch(data) {
  productData = data;
  fetching    = false;

  if (!productData) return;

  var variants = productData.variants || [];
  var options  = (productData.options || []).map(function(o) {
    return typeof o === 'string' ? o : (o.name || String(o));
  });

  var isSingleVariant = variants.length <= 1
    || (options.length === 1 && options[0] === 'Title');

  if (isSingleVariant) {
    /* ATC directly */
    var originalText = btn.textContent;
    btn.classList.add('loading');
    btn.textContent = '...';
    doATC(btn.dataset.variant, btn, originalText);
    return;
  }

  var variantSelected = btn.dataset.variantSelected === 'true';

  if (variantSelected) {
    /* Variant already chosen — ATC */
    var originalText = btn.textContent;
    btn.classList.add('loading');
    btn.textContent = '...';
    doATC(btn.dataset.variant, btn, originalText);
  } else {
    /* Show popup */
    if (popup) {
      popup.style.display = 'block';
      buildPopup(card, btn, productData);
    }
  }
}


        if (!productData && !fetching) {
          fetching = true;
          fetchProductData(handle, afterFetch);
        } else if (productData) {
          afterFetch(productData);
        }
      });

      /* Close button */
      if (popup) {
        var closeBtn = popup.querySelector('[data-cpw-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            popup.style.display = 'none';
          });
        }
      }
    });

    /* Close popup on outside click */
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.cpw-card-' + sid)) {
        slider.querySelectorAll('.cpw-popup').forEach(function(p) {
          p.style.display = 'none';
        });
      }
    });
  }
}

window.cartPairWidget = new CartPairWidget();


/* ═══════════════════════════════════════════
   CART PAIR SLIDER
═══════════════════════════════════════════ */
class CartPairSlider extends HTMLElement {
  constructor() {
    super();
    this._index      = 0;
    this._isDragging = false;
    this._startX     = 0;
  }

  connectedCallback() {
    if (this._bound) return;
    this._bound     = true;
    this._sectionId = this.dataset.sectionId;
    this._peek      = parseInt(this.dataset.peek) || 40;
    this._gap       = parseInt(this.dataset.gap)  || 12;

    this._bindDrag();
  }

  _updateTransform() {
    var cards = this.querySelectorAll('.cpw-card-' + this._sectionId);
    if (!cards.length) return;
    var cardW = cards[0].offsetWidth + this._gap;
    this.style.transform = 'translateX(-' + (this._index * cardW) + 'px)';
  }

  _bindDrag() {
    var self = this;

    this.addEventListener('mousedown', function(e) {
      self._isDragging = true;
      self._startX     = e.pageX;
      self.classList.add('is-dragging');
    });

    window.addEventListener('mouseup', function(e) {
      if (!self._isDragging) return;
      self._isDragging = false;
      self.classList.remove('is-dragging');
      var diff  = e.pageX - self._startX;
      var cards = self.querySelectorAll('.cpw-card-' + self._sectionId);
      var max   = Math.max(0, cards.length - 1);
      if (diff < -50 && self._index < max) self._index++;
      if (diff > 50  && self._index > 0)   self._index--;
      self._updateTransform();
    });

    this.addEventListener('touchstart', function(e) {
      self._startX = e.touches[0].pageX;
    }, { passive: true });

    this.addEventListener('touchend', function(e) {
      var diff  = e.changedTouches[0].pageX - self._startX;
      var cards = self.querySelectorAll('.cpw-card-' + self._sectionId);
      var max   = Math.max(0, cards.length - 1);
      if (diff < -50 && self._index < max) self._index++;
      if (diff > 50  && self._index > 0)   self._index--;
      self._updateTransform();
    }, { passive: true });

    window.addEventListener('resize', function() { self._updateTransform(); });
  }
}

if (!customElements.get('cart-pair-slider')) {
  customElements.define('cart-pair-slider', CartPairSlider);
}


/* ═══════════════════════════════════════════
   CART DRAWER REMOVE BUTTON
═══════════════════════════════════════════ */
class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-drawer').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);


/* ═══════════════════════════════════════════
   CART DRAWER
═══════════════════════════════════════════ */
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer             = document.getElementById('cart-drawer');
    this.cartButton         = document.querySelector('.js-open-cart');
    this.onBodyClick        = this.handleBodyClick.bind(this);
    this.pageOverlayElement = document.querySelector('.page-overlay');

    this.cartButton.addEventListener('click', this.handleCartClick.bind(this));
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    window.addEventListener('resize', () => { this.setHeight(); });

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => { this.onChange(event); }, 300);
    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.initEvents();

    /* Init pair widget — poll until slider element exists in DOM */
    (function waitForSlider() {
      var slider = document.querySelector('cart-pair-slider');
      if (slider) {
        window.cartPairWidget.init();
      } else {
        setTimeout(waitForSlider, 100);
      }
    })();
  }

  initEvents() {
    this.closeButtons = document.querySelectorAll('[data-close-drawer]');
    this.closeButtons.forEach(b => {
      b.addEventListener('click', this.close.bind(this));
    });
  }

  setHeight() {
    const windowHeight = window.innerHeight;
    const headerHeight = document.querySelector('.header-wrapper').offsetHeight;
    const newHeight    = windowHeight - headerHeight - 16 - 16;

    if (window.innerWidth > 599) {
      this.querySelector('#cart-drawer__content').style.height = '100%';
    } else {
      this.querySelector('#cart-drawer__content').style.height = `${newHeight}px`;
    }
  }

  open() {
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);
    this.pageOverlayElement.classList.add('is-visible');
    document.body.classList.add('overflow-hidden');
    document.body.addEventListener('click', this.onBodyClick);

    window.cartPairWidget.refresh();
  }

  close(event) {
    if (event) event.preventDefault();
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded');
    this.pageOverlayElement.classList.remove('is-visible');
    document.body.classList.remove('overflow-hidden');
    document.body.removeEventListener('click', this.onBodyClick);
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading();

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector)
            || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });

        this.closeButtons = document.querySelectorAll('[data-close-drawer]');
        this.closeButtons.forEach(b => {
          b.addEventListener('click', this.close.bind(this));
        });

        this.disableLoading();

        setTimeout(function() { window.cartPairWidget.refresh(); }, 150);
      })
      .catch(() => { this.disableLoading(); });
  }

  getSectionsToRender() {
    return [
      {
        id:       'cart-drawer__content',
        section:  document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id:       'cart-icon-bubble',
        section:  'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    const el = document.getElementById('cart-drawer-loading');
    if (el) el.classList.remove('hidden');
  }

  disableLoading() {
    const el = document.getElementById('cart-drawer-loading');
    if (el) el.classList.add('hidden');
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('page-overlay')) {
      this.close(evt);
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }

  handleCartClick(evt) {
    evt.preventDefault();
    this.open();
  }
}

customElements.define('cart-drawer', CartDrawer);

document.addEventListener('shopify:section:load', function() {
  setTimeout(function() { window.cartPairWidget.init(); }, 100);
});
